// extracted by mini-css-extract-plugin
module.exports = {"login":"login_login__2gh5w"};